module.exports = __webpack_public_path__ + "3400273b71e27e90c4a424d6d48d88f1.png";